export default initData => {
    const { searchParams, searchUrl } = initData;
    return {
        isFetching: false,
        error: null,
        queryParams: null,
        searchParams,
        searchUrl
    };
};
